
export const isValidOPFRFilename = (filename) => {
  const pattern = /^OPFR(\d{8})\d{7}\.csv$/i;
  return pattern.test(filename);
};

export const isCurrentDateInFilename = (filename) => {
  const pattern = /^OPFR(\d{8})\d{7}\.csv$/i;
  const match = filename.match(pattern);
  if (!match) return false;

  const fileDateStr = match[1]; // Extract yyyyMMdd

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const currentDate = `${yyyy}${mm}${dd}`;

  return fileDateStr === currentDate;
};